import {IInput} from '@gongxigames/framework/core/types/IInput';

export interface InputGesturesEventsMap {
    swipeToRight: undefined;
    swipeToLeft: undefined;
}

export interface IInputGestures extends IInput<InputGesturesEventsMap> {}
